
<f-dialog
    v-if         = "audit"
    v-model      = "show"
    :width       = "1200"
    :show-header = "true"
    :hide-actions = "true"
    :title       = "$t('audit.delta.title', [ type, audit.date ])"
    @cancel      = "onCancel"
>
    <template v-slot:content>
        <v-card
            class = "bg-white pa-2"
            flat
        >
            <div class="v-flex">
                <div class="history-ident primary--text">
                    Benutzer
                </div>
                <div class="history-time primary--text">
                    Datum
                </div>
                <div class="history-catalogue primary--text">
                    ID
                </div>
                <div class="history-rating primary--text">
                    Bewertung
                </div>
                <div class="history-measure primary--text">
                    Maßnahme
                </div>
                <div class="history-costs primary--text" style="text-align: center" v-if="!isEscalator">
                    Schätzkosten
                </div>
                <div class="history-notice primary--text">
                    Notiz
                </div>
            </div>
            <v-divider class="mt-1 mb-1" />
            <div class="history-scroll">
                <div v-for="(entry, index) in history" :key="index">
                    <v-divider v-if="index !== 0 && history[index].catalogueId !== history[index-1].catalogueId" />
                    <div class="v-flex">
                        <div class="history-ident">
                            {{ entry.ident }}
                        </div>
                        <div class="history-time">
                            {{ formatTime (entry.timestamp) }}
                        </div>
                        <div class="history-catalogue">
                            {{ code(entry.catalogueId) }}
                        </div>
                        <div class="history-rating">
                            {{ entry.ratingName }}
                        </div>
                        <div class="history-measure">
                            {{ entry.measureName }}
                        </div>
                        <div class="history-costs" v-if="!isEscalator">
                            {{ formatMoney (entry.costs) }}
                        </div>
                        <div class="history-notice">
                            {{ entry.notice }}
                        </div>
                    </div>
                </div>
            </div>
        </v-card>
    </template>
</f-dialog>
